import { createAsyncType } from '@/store/utils/mutation-types'

export default {
  GET_TEAMS: createAsyncType('GET_TEAMS')
}
